import FlumpObject from "../../general/objects/FlumpObject";
import { audioPlayer } from "../../PhaserExtension";

export default class StoryBall extends FlumpObject
{
    constructor(game, config, library)
    {
        super(game, config, library);

        this.closeScale = config.closeScale;
        this.farScale = config.farScale;
        this.tweenTime = config.tweenTime;
        this.onTweenComplete = new Phaser.Signal();
    }

    tweenTo(x, y)
    {
        // If a point is passed in, take the values from it
        if(typeof(x) === "object")
        {
            y = x.y;
            x = x.x;
        }

        this.visible = true;

        if(y > this.y)
        {
            this.loop(this.keys.rollTowards);
            this.game.add.tween(this.scale)
                         .to({x: this.closeScale.x, y: this.closeScale.y}, this.tweenTime, Phaser.Easing.Quadratic.InOut, true);
        }
        else
        {
            this.rotation = Phaser.Point.angle(this.position, new Phaser.Point(x, y)) - Math.PI/2;
            this.loop(this.keys.rollAway);
            this.game.add.tween(this.scale)
                         .to({x: this.farScale.x, y: this.farScale.y}, this.tweenTime, Phaser.Easing.Quadratic.InOut, true);

            this.game.add.tween(this)
                         .to({rotation: 0}, this.tweenTime, Phaser.Easing.Quadratic.InOut, true);
        }

        this.game.add.tween(this)
                     .to({x: x, y: y}, this.tweenTime, Phaser.Easing.Quadratic.InOut, true)
                     .onComplete.addOnce(this.onTweenFinished, this);

        audioPlayer.play(this.game, this.config.sound);
    }

    onTweenFinished()
    {
        this.loop(this.keys.idle);
        this.onTweenComplete.dispatch();
    }
}
